import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import * as React from "react";
import CarsCard from "../../Cards/CarsCard/CarsCard";
import SummaryFacilityCard from "../../Cards/FacilityCard/SummaryFacilityCard";
import classes from "../Accordion.module.css";

const FacilitySummaryAccordion = (props) => {
  return (
    <div className={classes.cardContainer}>
      <Accordion defaultExpanded className={classes.accordion} expanded={true}>
        <AccordionSummary
          aria-controls={props.site.clientId}
          id={props.site.clientId}
          className={classes.accordionSummary}
        >
          <SummaryFacilityCard
            site={props.site}
            userType={props.userType}
          ></SummaryFacilityCard>
        </AccordionSummary>
        <AccordionDetails className={classes.accordionDetails}>
          <CarsCard
            carsTokens={props?.carUserTokens}
            isViewMode={true}
          ></CarsCard>
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default FacilitySummaryAccordion;
